import { CommonUrls } from '../common'
import { URLS as ConfigUrls } from '@/config'
const FARMACLOUD_URL_ENV_CODE = process.env.VUE_APP_FARMACLOUD_URL_ENV_CODE

const GATEWAY_BASE_URL = `https://gateway${ConfigUrls.URL_ENV_CODE}.farmacloud.io/`
const OAUTH_BASE_URL = `https://accountsbackend${ConfigUrls.URL_ENV_CODE}.farmacloud.io`
const ROOT_SITE = `https://${FARMACLOUD_URL_ENV_CODE}.farmacloud.io/`
const LOGIN_URL = `${OAUTH_BASE_URL}/login-url`
const LOGOUT_URL = `${OAUTH_BASE_URL}/logout`
const TOKEN_URL = `${OAUTH_BASE_URL}/auth/user/v1/token`
const USER_INFO_URL = `${GATEWAY_BASE_URL}profile/v1/topbar-information`
const STORAGE_URL = 'https://public-storage.farmacloud.io'
const STORAGE_IMAGES = `${STORAGE_URL}/images/`
const SHELL_CONFIG_URL = process.env.VUE_APP_SHELL_CONFIG_URL || `${STORAGE_URL}/applications/shell-config/config-${ConfigUrls.TAG_ENV_CODE}.json`

export default {
  ...CommonUrls,
  GATEWAY_BASE_URL,
  OAUTH_BASE_URL,
  ROOT_SITE,
  LOGIN_URL,
  LOGOUT_URL,
  TOKEN_URL,
  USER_INFO_URL,
  SHELL_CONFIG_URL,
  STORAGE_IMAGES
}
